// interface FieldBlockAndFarmersInfo {
//   docId: string;
//   coordinates: string;
//   area: string;
//   phase2Id: string;
//   farmerId: string;
//   farmerName: string;
//   farmerAboutme: string | null;
//   farmerPhotoUrl: string | null;
// }

import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax

export function addMarkers(map, listOfFieldBlocks, history) {
  const coordinatesParsed = JSON.parse(listOfFieldBlocks[2].coordinates);
  console.log("arraydecoords =>", coordinatesParsed);
  console.log("coordinatesParsed[0] =>", coordinatesParsed[0][0]);

  for (const fieldblock of listOfFieldBlocks) {
    // Create a DOM element for each marker.
    const el = document.createElement("div");
    const width = 40;
    const height = 40;
    el.className = "marker";
    el.style.backgroundImage =
      "url(https://firebasestorage.googleapis.com/v0/b/coopasvtech.appspot.com/o/40x40OnlySymbolCOOPASV.png?alt=media&token=494ac102-0439-41ce-9ca4-7b047726f6c0)";
    el.style.width = `${width}px`;
    el.style.height = `${height}px`;
    el.style.backgroundSize = "100%";

    const coordinatesParsed = JSON.parse(fieldblock.coordinates);

    // let farmerAboutme = "...";

    // if (fieldblock.farmerAboutme) {
    //   const truncate = (str, n) => {
    //     return str.length > n ? str.substr(0, n - 1) + "..." : str;
    //   };
    //   farmerAboutme = truncate(fieldblock.farmerAboutme, 100);
    // }

    // // create the popup
    // const popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
    // <strong>${fieldblock.farmerName}</strong> </br>

    // <p>${farmerAboutme}</p>
    // <a href="http://www.capitalpride.org/parade" target="_blank" title="Opens in a new window">Continue lendo...</a> </br>
    // `);

    el.addEventListener("click", () => {
      history.push(`/farmer/${fieldblock.farmerId}`);
    });

    // Add markers to the map.
    new mapboxgl.Marker(el)
      .setLngLat(coordinatesParsed[0][0])
      // .setPopup(popup)
      .addTo(map);
  }
}
